import { of } from 'rxjs/observable/of';
import { isNullOrUndefined } from 'util';
import * as R from 'ramda';

export const getEmptyAsyncObj = () => of({});

export const getNullAsync = () => of(null);

export const equals = R.curry((a: any, b: any) => a === b);

export const isEmpty = (object: any) => isNullOrUndefined(object) || Object.keys(object).length === 0;

export const isNotEmpty = <T> (object: T) => !isNullOrUndefined(object);

export const parse = (value: string) => (isNullOrUndefined(value)) ? null : JSON.parse(value);



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/utils/object.utils.ts